import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

const API = process.env.REACT_APP_BACKEND_URL;

function Stat({ label, value, sub, color }) {
  return (
    <div className="rounded-lg border p-4">
      <div className={"text-2xl font-bold " + (color || "")}>{value}</div>
      <div className="text-sm text-gray-500">{label}</div>
      {sub ? <div className="text-xs text-gray-400 mt-1">{sub}</div> : null}
    </div>
  );
}

export default function KpisPerformancePage() {
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/api/kpis-performance`, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
        setD(r.data);
      } catch (e) {}
      setLoading(false);
    })();
  }, []);
  const exportEnc = async () => {
    try {
      const r = await axios.get(`${API}/api/kpis-performance/export-encaissements`, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }, responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement("a"); a.href = url; a.download = "encaissements.csv"; a.click(); window.URL.revokeObjectURL(url);
    } catch (e) { window.alert("Erreur export"); }
  };
  if (loading) return <p className="text-sm text-gray-500">Chargement...</p>;
  if (!d) return <p className="text-sm text-red-600">Impossible de charger les KPIs.</p>;
  const eur = (x) => (x || 0).toLocaleString("fr-FR") + " EUR";
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-secondary">KPIs / Performance</h1>
        <p className="text-sm text-gray-500">Indicateurs evenementiels : CA, encaissements, participation, sondages, satisfaction.</p>
        <button onClick={exportEnc} className="mt-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm px-3 py-2 rounded-md">Exporter les encaissements (CSV)</button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        <Stat label="CA total (bilans)" value={eur(d.ca_total)} />
        <Stat label="Encaisse" value={eur(d.encaisse)} color="text-green-600" />
        <Stat label="Impaye" value={eur(d.impaye)} color="text-red-600" />
        <Stat label="Taux participation" value={(d.taux_participation || 0) + " %"} sub={d.participants_places + "/" + d.participants_total} />
        <Stat label="Reponse sondages" value={(d.taux_reponse_sondages || 0) + " %"} sub={d.sondages_repondus + "/" + d.sondages_envoyes} />
        <Stat label="Satisfaction /5" value={d.note_moyenne_satisfaction != null ? d.note_moyenne_satisfaction : "-"} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Card>
          <CardHeader><CardTitle className="text-lg">CA par evenement</CardTitle></CardHeader>
          <CardContent className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-gray-500 border-b"><th className="py-2 pr-3">Evenement</th><th className="py-2 pr-3">CA</th></tr></thead>
              <tbody>
                {(d.ca_par_evenement || []).map((l, i) => (
                  <tr key={i} className="border-b hover:bg-gray-50"><td className="py-2 pr-3">{l.evenement}</td><td className="py-2 pr-3">{eur(l.ca)}</td></tr>
                ))}
                {(d.ca_par_evenement || []).length === 0 && <tr><td colSpan={2} className="py-4 text-center text-gray-400">Aucun bilan avec CA pour l'instant.</td></tr>}
              </tbody>
            </table>
          </CardContent>
        </Card>
        <Card>
          <CardHeader><CardTitle className="text-lg">Food trucks les plus actifs</CardTitle></CardHeader>
          <CardContent className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-gray-500 border-b"><th className="py-2 pr-3">Food truck</th><th className="py-2 pr-3">Participations</th></tr></thead>
              <tbody>
                {(d.top_food_trucks || []).map((l, i) => (
                  <tr key={i} className="border-b hover:bg-gray-50"><td className="py-2 pr-3 font-medium">{l.nom}</td><td className="py-2 pr-3">{l.participations}</td></tr>
                ))}
                {(d.top_food_trucks || []).length === 0 && <tr><td colSpan={2} className="py-4 text-center text-gray-400">Aucune participation.</td></tr>}
              </tbody>
            </table>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
